import styled from "styled-components/macro";

import type { ThemeProps as Props } from "models/styles/theme";

import { InputWithErrorMessage } from "components/InputWithErrorMessage";

export const StyledInput = styled(InputWithErrorMessage)<Props>`
  border-radius: 4px;
`;
